export function convert_1920_1560(px: number) {
  return (px * 1560) / 1920
}

export function pxToRem(px: number, designSize = 1560) {
  return `${(px * 1560) / designSize / 100}rem`
}
